<template>
<v-card>
        <v-toolbar flat>
          <v-icon class="mr-2" color="grey">mdi-calendar-clock</v-icon>
          <v-toolbar-title>Kies een tijd</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        
       
       
        <v-card-text :style="largeScreen? 'height: 500px;' : 'height: 300px;'" class="px-2 pt-5">
          <template v-for="(item,i) in list">
          <v-chip-group
              column
                :key="i"
              class="ma-0 pa-0 d-flex"
            >
            <v-chip v-for="t in item.slots"
                  :key="t.time" @click="select(t.date,false)"
                  :value="t" label :disabled="!t.date"
                  :outlined="timeValue!=t.time || asap" 
                  :style="`${timeValue==t.time && !asap ? 'margin-left: 1px;margin-right: 9px;' : ''}`"
                  :color="(timeValue==t.time && !asap) ? 'primary' : null"
                  :dark="timeValue==t.time && !asap"
                  class="ma-0 mr-1 mb-1 text-body-1 flex-grow-1 flex-shrink-0 justify-center"
                  :class="{'mr-0' : t.time.includes(':00')}">{{t.time}}</v-chip>
            </v-chip-group>
          
          </template>
        </v-card-text>
        <v-card-actions>
            <v-chip
                 @click="select(null,true)"
                 label
                  :outlined="!asap" 
                  :style="`${asap ? 'margin-left: 1px;margin-right: 9px;' : ''}`"
                  color="primary"
                  :dark="asap"
                  class="ma-0 mr-1 mb-1 text-body-1 pr-11 flex-grow-1 flex-shrink-0 justify-center"
                  >Zo snel mogelijk om {{firstDate | moment('HH:mm')}}</v-chip>
         
        </v-card-actions>
      </v-card>
</template>
<script>
export default {
   props: {
    value: {
      type: Object,
      default: function () {
        return null
      },
    },
    firstDate: {
      type: Object,
      default: function () {
        return null
      },
    },
    list: {
      type: Array,
      default: function () {
        return []
      },
    },
    asap: {
      type: Boolean,
      default: function () {
        return true
      },
    }
   },
  data: () => ({
      
  }),
  computed: {
    due(){
        this.value
    },
    timeValue(){
      return this.$moment(this.due).format('HH:mm')
    },
  },
  mounted () {
  
  },
  methods: {
    select(date,asap){
        this.$emit('select', {date,asap})
    },
    close(item){
        this.$emit('close')
    }
  }
}

</script>